/**
 * @generated SignedSource<<0b2f5f44bd64ba7831c6ee7b039fb54f>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34

import type { ConcreteRequest } from 'relay-runtime';
export type useCopyContentLinkQuery$variables = {
  contentId: string;
};
export type useCopyContentLinkQuery$data = {
  readonly singleContent: {
    readonly id: string | null;
    readonly links: {
      readonly base: string | null;
      readonly editui: string | null;
      readonly tinyui: string | null;
      readonly webui: string | null;
    } | null;
  } | null;
};
export type useCopyContentLinkQuery = {
  response: useCopyContentLinkQuery$data;
  variables: useCopyContentLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "editui"
          },
          {
            "kind": "ScalarField",
            "name": "webui"
          },
          {
            "kind": "ScalarField",
            "name": "tinyui"
          },
          {
            "kind": "ScalarField",
            "name": "base"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCopyContentLinkQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCopyContentLinkQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29cac5aad51907935410d62eca7f1996",
    "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
    "metadata": {},
    "name": "useCopyContentLinkQuery",
    "operationKind": "query",
    "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
  }
};
})();

(node as any).hash = "37d735340f7b52ac7552b4a67a3fb5da";

export default node;
